<script setup lang="ts">
import { joinURL } from 'ufo';

import type { SaleAssetBusEntity } from '~/apiClient';

// CONSTANTS
const documents = [
    'registrationDocument',
    'registrationDocumentPartTwo',
    'technicalSheet',
    'cocDocument',
    'maintenanceCard',
    'inspectionAndMileageCheck',
] as const;

// PROPS
interface Props {
    asset: SaleAssetBusEntity;
}

defineProps<Props>();

// COMPOSABLES
const { tt } = useTypedI18n();
const { trackFileDownload } = useTracking();

// DATA
const baseURL = useRuntimeConfig().public.cdnMediaBaseUrl;
</script>

<template>
    <div class="flex flex-col gap-6">
        <h3 class="text-highlighted text-2xl font-semibold md:text-3xl">{{ tt('sdp.papers') }}</h3>
        <div class="flex flex-wrap gap-3">
            <BaseTooltip v-if="!asset.cocDocument" :text="tt('sdp.cocDocumentAbsent')" :content="{ side: 'top' }">
                <UButton color="neutral" variant="subtle" size="lg" :label="tt(`sdp.cocDocument`)" leading-icon="lucide:file-x-2" disabled />
            </BaseTooltip>
            <template v-for="doc in documents" :key="doc">
                <UButton
                    v-if="asset[doc]"
                    variant="soft"
                    size="lg"
                    :label="tt(`sdp.${doc}`)"
                    leading-icon="lucide:download"
                    :to="joinURL(baseURL, asset[doc]!)"
                    target="_blank"
                    @click="
                        () => {
                            asset[doc] && trackFileDownload(doc, 'pdf');
                        }
                    "
                />
            </template>
        </div>
    </div>
</template>
